import Home from './Pages/Home';
import Header from './Components/Header'
import SecondNav from './Components/SecondNav'
import Footer from './Components/Footer'
import { Routes, Route, useLocation } from "react-router-dom"
import Products from './Pages/Products';
import Cart from './Pages/Cart';
import Login from './Pages/Login';
import SignUp from './Pages/SignUp';
import AboutUs from './Pages/AboutUs';
import BlogsPage from './Pages/BlogsPage';
import ContactUs from "./Pages/ContactUs"
import { AnimatePresence} from "framer-motion"
import Checkout from './Pages/Checkout';


function App() {
 
  const Location = useLocation();

  return (
    <div className="App">
       <Header />
        <SecondNav />
<AnimatePresence>
      <Routes location={Location} key={Location.key}>

                  <Route path='/' element={ <Home />}/>
                  <Route path='/products' element={ <Products />}/>
                  <Route path='/cart' element={ <Cart />}/>
                
                  <Route path='/signup' element={   <SignUp /> }/>
                  <Route path='/aboutus' element={   <AboutUs /> }/>
                  <Route path='/contact' element={   <ContactUs /> }/>
                  <Route path='/blog' element={   <BlogsPage /> }/>
                  <Route path='/checkout' element={   <Checkout/> }/>
                      
      </Routes>
      </AnimatePresence>
      
       <Footer />
    </div>
  );
}

export default App;
